interface DotsLoadingProps {
  className?: string;
}

export default function DotsLoading({ className = "" }: DotsLoadingProps) {
  return (
    <div className={`flex items-center justify-center gap-1.5 ${className}`}>
      <span className="size-2 rounded-full bg-primary animate-bounce [animation-delay:-0.3s]" />
      <span className="size-2 rounded-full bg-primary animate-bounce [animation-delay:-0.15s]" />
      <span className="size-2 rounded-full bg-primary animate-bounce" />
    </div>
  );
}
